import { NavigateWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Navigate')
export class NavigateConnectorProvider extends ConnectorProvider<NavigateWorkflowNode> {}
